import 'reflect-metadata';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig, getEnv } from './app/app.config';
import { AppComponent } from './app/app.component';
import { startErrorReporting } from './app/error-reporting';

// Started first, so that errors during bootstrap are reported too.
startErrorReporting('client', getEnv().faroUrl).then(() =>
  bootstrapApplication(AppComponent, appConfig).catch((err) =>
    console.error(err),
  ),
);
